import { create } from "zustand";

export const useMessageNotificationCount = create((set) => ({
  messagesCount: 0,
  addMessagesCount: (data: any) => set(() => ({ messagesCount: data })),
}));
